module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_maripic@2x-47f1f873139d0b7525dc30079fbad5dd.webp";